import { Dict, Lang, _t } from '@/lib/i18n';
import ar from '@/public/assets/Images/flags/ar.png';
import en from '@/public/assets/Images/flags/en.png';
import es from '@/public/assets/Images/flags/es.png';
import fr from '@/public/assets/Images/flags/fr.png';
import hi from '@/public/assets/Images/flags/hi.png';
import pt from '@/public/assets/Images/flags/pt.png';
import ru from '@/public/assets/Images/flags/ru.png';
import zh from '@/public/assets/Images/flags/zh.png';

export type LanguageType = { name: string; flag: any; link: string };

export const languages: LanguageType[] = [
  { flag: en, link: 'en', name: 'English' },
  { flag: pt, link: 'pt', name: 'Portuguese' },
  { flag: es, link: 'es', name: 'Spanish' },
  { flag: zh, link: 'zh', name: 'Chinese' },
  { flag: ru, link: 'ru', name: 'Russian' },
  { flag: hi, link: 'hi', name: 'Hindi' },
  { flag: ar, link: 'ar', name: 'Arabic' },
  { flag: fr, link: 'fr', name: 'French' },
];

interface DictonariesType {
  [key: string]: () => Promise<Dict>;
}

const dictionaries: DictonariesType = {};

languages.forEach(({ link }) => {
  dictionaries[link] = () =>
    import(`@/public/translations/${link}.json`).then((module) => module.default);
});

export const getDictionary = async (lang: Lang = 'en') =>
  ((await dictionaries[lang]) || dictionaries.en)();

export type Translator = (key: string) => string;

export const getTranslations = async (lang: Lang = 'en'): Promise<Translator> => {
  const dict = await getDictionary(lang);
  return (key: string) => _t(key, dict);
};
